const Const = {
    RETURN_COMMENTS_AREAS_CLEAN_COMMENT: 'RETURN_COMMENTS_AREAS_CLEAN_COMMENT',
    RETURN_COMMENTS_COMMENT_WAS_CHANGED: 'RETURN_COMMENTS_COMMENT_WAS_CHANGED',
    RETURN_COMMENTS_COMMENT_SET_TO_FALSE: 'RETURN_COMMENTS_COMMENT_SET_TO_FALSE',
};

export default Const;